<template>
  <div class="login">
    <router-link to="/auth/login">
      <span>{{ $t('header.a.login') }}</span>
      <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      >
        <g>
          <path
            d="m13 2h3.3333c.4421 0 .866.1873 1.1785.5207.3126.3334.4882.78558.4882 1.25708v12.44442c0 .4715-.1756.9237-.4882 1.2571-.3125.3334-.7364.5207-1.1785.5207h-3.3333"
          />
          <path d="m8.33337 14.1667 4.16663-4.1667-4.16663-4.16666" />
          <path d="m12.5 10h-10" />
        </g></svg
    ></router-link>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.header_area .login {
  a {
    color: #fff;

    span {
      margin-right: 8px;
    }

    &:hover {
      color: $primary-color2;
    }
    &:hover svg {
      stroke: $primary-color2;
    }

    svg {
      margin-top: -1px;
      transition: stroke 0.3s;
    }
  }
}
</style>
